import Axios from "axios";
import Firebase from "firebase";
import moment from "moment";
import store from "../store";

const AdminReservationStore = {
  namespaced: true,
  debug: true,
  state: {
    adminReservationList: []
  },
  mutations: {
    setAdminReservationList(state, data) {
      state.adminReservationList = data;
    }
  },
  getters: {
    getAdminReservationList(state) {
      return state.adminReservationList.map(val => {
        let result = {
          schedulenumber: val.schedulenumber,
          day: moment(val.startdate).format("YYYY/MM/DD"),
          startTime: moment(val.startdate).format("Ah:mm 開始"),
          type:
            val.type != null && val.type != ""
              ? store.getters[
                  "constantStore/constant/constantStore/getTypeData"
                ](val.type).label
              : ""
        };
        if (val.status === "Reserved") {
          result.status = "予約中";
          result.color = "red";
        } else {
          result.status = "利用済";
          result.color = "grey";
        }
        return result;
      });
    }
  },
  actions: {
    async callApiAdminReservationList({ commit }, uid) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let adminReservationList = await Axios.post(
            process.env.VUE_APP_API_URL + "api/admin/reservationList",
            {
              uid: uid
            },
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setAdminReservationList", adminReservationList.data);
        })
        .catch(function() {
          // Handle error
        });
    }
  }
};
export default AdminReservationStore;
